<script>
import Icon from 'next/icon/Icon.vue';

export default {
  components: {
    Icon,
  },
};
</script>

<template>
  <label
    class="my-3.5 px-4 absolute ltr:right-0 rtl:left-0 top-0 text-xs flex items-center rtl:flex-row-reverse gap-0.5 text-red-400"
  >
    <Icon icon="i-lucide-circle-slash-2" class="size-3" />
    <span>{{
      $t('WGPT_BOTS.EDIT.TABS.KNOWLEDGE_BASE.TABS.ITEMS.CHUNKS.ITEM.DISABLED')
    }}</span>
  </label>
</template>
